import * as React from 'react';
import classnames from 'classnames';

type Props = {
  children: React.ReactNode,
  noMargin?: boolean,
  align?: 'center',
  className?: string
};

class ModalFrameFooter extends React.PureComponent<Props> {
  static defaultProps = {
    align: 'center'
  };

  render() {
    const { align, noMargin, children, className } = this.props;

    const classes = classnames('modal-frame-footer', className, {
      [`modal-frame-footer--align-${String(align)}`]: align,
      'modal-frame-footer--no-margin': noMargin
    });

    return (
      <div className={classes}>
        {children}
      </div>
    );
  }
}

export default ModalFrameFooter;
